import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { useScopedAppFlagStore } from '@frontend/scope';
import { useHasCallIntelAclAccess, UseHasCallIntelAclAccessOptions } from './use-has-call-intel-acl-access';
import { useIsCallIntelEligibleAccount } from './use-is-call-intel-eligible-account';

type UseCallIntelFeatureAccessOptions = {
  permissions?: Permission[];
  featureFlagKey?: string;
  aclOptions?: UseHasCallIntelAclAccessOptions;
};

export const useCallIntelFeatureAccess = ({
  permissions = [],
  featureFlagKey,
  aclOptions,
}: UseCallIntelFeatureAccessOptions = {}) => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const hasPermission = useHasCallIntelAclAccess(permissions, aclOptions);
  const { isCallIntelActive: hasCallIntelFeature } = useIsCallIntelEligibleAccount();

  const isFlagEnabled = featureFlagKey ? getFeatureFlagValue(featureFlagKey) : true;

  const isAccessible = hasPermission && hasCallIntelFeature && isFlagEnabled;

  const shouldHideFeature = !isFlagEnabled || !hasCallIntelFeature || !hasPermission;

  return {
    isAccessible,
    hasPermission,
    hasCallIntelFeature,
    isFlagEnabled,
    shouldHideFeature,
  };
};
